import { renderMermaidDiagram, type MermaidRenderResult } from '@agentteams/mermaid-renderer';

export type { MermaidRenderResult };

/**
 * Web 쪽 Mermaid 렌더 진입점.
 *
 * 렌더링 정책(strict 초기화, init directive 제거, 입력 상한, parse 선검증, timeout,
 * 기본 오류 SVG 차단, SVG 재살균, 캐시)은 `@agentteams/mermaid-renderer`가 단독으로 갖는다.
 * desktop AI 채팅도 같은 모듈을 쓰므로, 정책을 바꿀 일이 생기면 이 파일이 아니라 그 패키지를 고친다.
 *
 * 이 파일에 남는 책임은 하나뿐이다: **web의 페이지 테마 이름을 mermaid theme으로 번역**하는 것.
 */

/** 페이지 테마는 daisyUI 테마 이름이고, mermaid가 아는 theme은 `default`/`dark`뿐이다. */
const resolveMermaidTheme = (pageTheme: string): string => (pageTheme === 'night' ? 'dark' : 'default');

export const renderMermaidSvg = async (source: string, pageTheme = 'default'): Promise<MermaidRenderResult> => {
  return renderMermaidDiagram(source, { theme: resolveMermaidTheme(pageTheme) });
};
